import React from 'react';
import { Dialog, DialogTitle, DialogContent, Grid, Button, DialogActions } from '@material-ui/core';
import { FormikValues, Formik, Form } from 'formik';
import PersonRoundedIcon from '@material-ui/icons/PersonRounded';

import useAuth from 'hooks/useAuth';
import { FormikInput, Loading } from 'components';
import { resetEmailValidationSchema } from './ValidationSchema';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const EmailResetDialog: React.SFC<Props> = (props) => {
  const { isOpen, onClose } = props;
  const { user, isLoading, updateEmail } = useAuth();

  const initialValues = { email: user.email };

  const handleFormSubmit = async (values: FormikValues) => {
    const { email } = values;
    await updateEmail(email);
    // TODO: show error message
    // TODO: update the user;s email in the provider
    onClose();
  };

  const renderForm = () => (
    <Formik
      initialValues={initialValues}
      validationSchema={resetEmailValidationSchema}
      onSubmit={handleFormSubmit}
    >
      {({ isValid }) => (
        <Form>
          <DialogContent>
            <Grid item>
              <FormikInput title="Email" name="email" endAdornment={<PersonRoundedIcon />} />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={onClose}>
              Cancel
            </Button>
            {/* TODO: make loading button component */}
            <Button type="submit" color="primary" disabled={!isValid || isLoading}>
              {isLoading && <Loading size={20} style={{ marginTop: '-10px' }} />}
              {!isLoading && 'Update'}
            </Button>
          </DialogActions>
        </Form>
      )}
    </Formik>
  );

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={isOpen}
      onClose={onClose}
      aria-labelledby="password-dialog-title"
    >
      <DialogTitle id="password-dialog-title">Reset Your Email</DialogTitle>
      {renderForm()}
    </Dialog>
  );
};

export default EmailResetDialog;
